/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenResponse } from '../../models/token-response';

export interface PostRequestToken$Params {
  userName: string;
  password: string;
  signature: string;
}

export function postRequestToken(http: HttpClient, rootUrl: string, params: PostRequestToken$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenResponse>> {
  const rb = new RequestBuilder(rootUrl, postRequestToken.PATH, 'post');
  if (params) {
    rb.query('userName', params.userName, {"style":"form"});
    rb.query('password', params.password, {"style":"form"});
    rb.query('signature', params.signature, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenResponse>;
    })
  );
}

postRequestToken.PATH = '/requesttoken';
